module.exports = __webpack_public_path__ + "img/CLOSED.4ffca042.png";